export interface IBreakpointFunctions {
    xxlFunc?: Function;
    xlFunc?: Function;
    lgFunc?: Function;
    mdFunc?: Function;
    smFunc?: Function;
    xsFunc?: Function;
}

export function BreakpointFunction(functions: IBreakpointFunctions) {
    if (window.matchMedia('(min-width: 1400px)').matches) {
        console.debug("Media breakpoint XXL");
        if (functions.xxlFunc) {
            functions.xxlFunc();
        }
    }
    if (window.matchMedia('(max-width: 1399.98px)').matches) {
        if (window.matchMedia('(min-width: 1200px)').matches) {
            console.debug("Media breakpoint XL");
            if (functions.xlFunc) {
                functions.xlFunc();
            }
        }
    }
    if (window.matchMedia('(max-width: 1199.98px)').matches) {
        if (window.matchMedia('(min-width: 992px)').matches) {
            console.debug("Media breakpoint LG");
            if (functions.lgFunc) {
                functions.lgFunc();
            }
        }
    }
    if (window.matchMedia('(max-width: 991.98px)').matches) {
        if (window.matchMedia('(min-width: 768px)').matches) {
            console.debug("Media breakpoint MD");
            if (functions.mdFunc) {
                functions.mdFunc();
            }
        }
    }
    if (window.matchMedia('(max-width: 767.98px)').matches) {
        if (window.matchMedia('(min-width: 576px)').matches) {
            console.debug("Media breakpoint SM");
            if (functions.smFunc) {
                functions.smFunc();
            }
        }
    }
    if (window.matchMedia('(max-width: 575.98px)').matches) {
        console.debug("Media breakpoint XS");
        if (functions.xsFunc) {
            functions.xsFunc();
        }
    }
}